// Local sample catalogue for the frontend preview. Shared by /collection and /product/:slug.
// Prices are editable sample values; nothing here is a verified claim.
// Images: Phase 04A-R1 optimized WebP (same pixel dimensions as the originals). Consumers wrap them in cdn().

export const productCategories = ['Croissants', 'Pastries', 'Bread', 'Seasonal'] as const;

export const products = [
  {
    id: 'p01',
    slug: 'classic-croissant',
    name: 'Classic Croissant',
    category: 'Croissants',
    note: 'Twenty-seven butter layers and a shattering crust.',
    description: 'Laminated by hand over three days with cultured butter, proofed slowly and baked dark at dawn. Crisp on the outside, weightless and honeyed within.',
    ingredients: 'Wheat flour, cultured butter, whole milk, water, sugar, sea salt, fresh yeast, egg wash.',
    allergens: 'Contains gluten, dairy and egg.',
    price: 5.5,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-croissant-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-croissant-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-croissant-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-croissant-3.webp',
    ],
  },
  {
    id: 'p02',
    slug: 'pain-au-chocolat',
    name: 'Pain au Chocolat',
    category: 'Croissants',
    note: 'Two batons of dark chocolate, folded into layers.',
    description: 'Our croissant dough wrapped around two batons of dark chocolate. The chocolate stays soft while the layers bake crisp and glossy.',
    ingredients: 'Wheat flour, cultured butter, dark chocolate (cocoa mass, sugar, cocoa butter, soy lecithin), whole milk, sugar, sea salt, fresh yeast, egg wash.',
    allergens: 'Contains gluten, dairy, egg and soy.',
    price: 6,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-painchoc-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-painchoc-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-painchoc-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-painchoc-3.webp',
    ],
  },
  {
    id: 'p03',
    slug: 'country-sourdough',
    name: 'Country Sourdough',
    category: 'Bread',
    note: 'Naturally leavened over 24 hours. Blistered and dark.',
    description: 'A wild-yeast loaf fermented slowly overnight and baked on the stone deck until the crust blisters and darkens. Glossy, open crumb with a gentle sourness.',
    ingredients: 'Wheat flour, wholemeal wheat flour, water, sourdough starter, sea salt.',
    allergens: 'Contains gluten.',
    price: 9,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-sourdough-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-sourdough-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-sourdough-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-sourdough-3.webp',
    ],
  },
  {
    id: 'p04',
    slug: 'kouign-amann',
    name: 'Kouign-Amann',
    category: 'Pastries',
    note: 'Caramelised edges, a soft salted centre.',
    description: 'Laminated dough folded with sugar and salted butter, baked in a tin until the edges caramelise to deep amber. Baked dark on purpose.',
    ingredients: 'Wheat flour, salted butter, sugar, water, fresh yeast, sea salt.',
    allergens: 'Contains gluten and dairy.',
    price: 6.5,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-kouign-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-kouign-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-kouign-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-kouign-3.webp',
    ],
  },
  {
    id: 'p05',
    slug: 'almond-croissant',
    name: 'Almond Croissant',
    category: 'Croissants',
    note: 'Twice-baked, filled with frangipane.',
    description: 'Yesterday\u2019s croissant, soaked in light syrup, filled with almond frangipane and baked again under flaked almonds.',
    ingredients: 'Wheat flour, cultured butter, ground almonds, flaked almonds, sugar, egg, whole milk, sea salt, fresh yeast, icing sugar.',
    allergens: 'Contains gluten, dairy, egg and tree nuts (almond).',
    price: 7,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-almond-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-almond-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-almond-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-almond-3.webp',
    ],
  },
  {
    id: 'p06',
    slug: 'seeded-rye',
    name: 'Seeded Rye',
    category: 'Bread',
    note: 'Toasted seeds, cracked grain, a malty crumb.',
    description: 'A dense, tin-baked rye packed with toasted sunflower and sesame seeds. Slices thinly and keeps well for several days.',
    ingredients: 'Rye flour, wheat flour, water, rye sourdough starter, sunflower seeds, sesame seeds, linseed, malt, sea salt.',
    allergens: 'Contains gluten and sesame.',
    price: 10.5,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-rye-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-rye-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-rye-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-rye-3.webp',
    ],
  },
  {
    id: 'p07',
    slug: 'cardamom-bun',
    name: 'Cardamom Bun',
    category: 'Pastries',
    note: 'Knotted, fragrant, finished with pearl sugar.',
    description: 'Laminated dough rolled with cardamom butter, twisted into a knot and glazed with a light syrup before a scatter of pearl sugar.',
    ingredients: 'Wheat flour, butter, whole milk, sugar, ground cardamom, pearl sugar, egg, fresh yeast, sea salt.',
    allergens: 'Contains gluten, dairy and egg.',
    price: 5.75,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-cardamom-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-cardamom-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-cardamom-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-cardamom-3.webp',
    ],
  },
  {
    id: 'p08',
    slug: 'fig-frangipane-tart',
    name: 'Fig & Frangipane Tart',
    category: 'Seasonal',
    note: 'Autumn only. Roasted figs on almond cream.',
    description: 'A short, buttery tart shell filled with almond frangipane and set with halved figs, roasted until jammy. Available while figs are in season.',
    ingredients: 'Wheat flour, butter, figs, ground almonds, sugar, egg, sea salt, vanilla.',
    allergens: 'Contains gluten, dairy, egg and tree nuts (almond).',
    price: 8.5,
    coverImage: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-figtart-1.webp',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-figtart-1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-figtart-2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_pd-figtart-3.webp',
    ],
  },
];